import React, { useState } from 'react'
import { string } from 'prop-types'
import classnames from 'classnames'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Paper from 'components/atoms/Paper'
import SectionTitle from 'components/atoms/SectionTitle'
import Ellipsis from 'components/atoms/Ellipsis'
import Markdown from 'components/atoms/MarkdownContent'
import Button from 'components/atoms/Button'

import config from 'config'

const { assets_url: assetsUrl } = config

const ScholarshipTermsCondition = ({ title, description }) => {
  const [collapsed, setCollapsed] = useState(true)
  const activeToggle = description.length > 1100
  const collapseableClass = classnames('scholarship-tnc__description', {
    collapsed: activeToggle && collapsed,
  })

  const toggleCollapse = () => setCollapsed(!collapsed)

  return (
    <div id="terms-condition" className="scholarship-tnc">
      <SectionContainer
        paddingTop={80}
        paddingBottom={120}
        backgroundColor="#f6f7fa"
      >
        <Container>
          <Paper rounded shadowed>
            <div className="scholarship-tnc__detail">
              <SectionTitle title={title || 'Persyaratan'} />
              { (activeToggle && collapsed) ?
                <Ellipsis text={description} clamp={10} markdown className={collapseableClass} /> :
                <Markdown className={collapseableClass} content={description} />
              }
            </div>
            {
              activeToggle &&
              <div className="scholarship-tnc__action">
                <Button
                  className="scholarship-tnc__toggle-btn"
                  component="button"
                  variant="secondary"
                  onClick={toggleCollapse}
                >
                  {
                    collapsed ? 'Baca Selengkapnya . . .' : 'Sembunyikan'
                  }
                </Button>
              </div>
            }
          </Paper>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .scholarship-tnc {
            &__detail {
              padding: 32px 16px;
              @media screen and (min-width: 768px) {
                padding: 64px 80px;
              }
            }
            &__action {
              margin-top: -32px;
              padding: 0 0 32px;
              text-align: center;
            }
            :global(&__toggle-btn) {
              border: none;
              font-weight: bold;
              font-size: 16px;
              &:hover{
                background-color: transparent;
                text-decoration: underline;
              }
            }
            :global(&__description) {
              max-height: 3000px;
              transition: max-height 0.3s ease-out;
              font-size: 16px;
              line-height: 2;
            }
            :global(&__description.collapsed) {
              transition: max-height 0.5s ease-out;
              max-height: 330px;
              overflow: hidden;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 48px;
                background-image: linear-gradient(
                  to bottom, rgba(255, 255, 255, 0), rgb(255, 255, 255)
                );
              }
            }
            :global(.campus-section) {
              background-image: url('${assetsUrl}/assets/img/blue-rect-2.svg'), url('${assetsUrl}/assets/img/blue-rect-1.svg');
              background-repeat: no-repeat;
              background-position: top 250px left 0, top 225px right 0;
            }
          }
        `}
      </style>
    </div>
  )
}

ScholarshipTermsCondition.propTypes = {
  title: string,
  description: string,
}

export default ScholarshipTermsCondition
